let bridge = null;
export const setCreditsBridge = (next) => {
    bridge = next;
};
export const emitCreditsHeaders = (payload) => {
    bridge?.onHeaders(payload);
};
export const emitInsufficientCredits = (info) => {
    bridge?.onInsufficientCredits(info);
};
export const emitLastCreditSpent = (info) => {
    bridge?.onLastCreditSpent(info);
};
/**
 * Whether this response is the one that emptied the balance. Only a charged
 * response counts: an uncharged zero is a refusal (the 402 path owns that) or
 * a balance read, and "unlimited" is never empty. Judged per response rather
 * than off the store, so a late-arriving response cannot re-trigger it.
 */
export const spentLastCredit = (payload) => payload.charged && payload.left === 0;
const CREDITS_LEFT_HEADER = "x-credits-left";
const CREDIT_CHARGED_HEADER = "x-credit-charged";
/** Axios lowercases response header keys, but normalize defensively anyway. */
const readHeader = (headers, key) => {
    if (!headers || typeof headers !== "object")
        return undefined;
    const record = headers;
    const raw = record[key] ?? record[key.toUpperCase()];
    return typeof raw === "string" || typeof raw === "number"
        ? String(raw)
        : undefined;
};
const parseTotal = (raw) => {
    if (raw === "unlimited")
        return "unlimited";
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : undefined;
};
/**
 * Returns null for any response that isn't a metered route — only the metered
 * routes send these headers, so their absence is the signal to do nothing.
 */
export const parseCreditsHeaders = (headers) => {
    const rawLeft = readHeader(headers, CREDITS_LEFT_HEADER);
    if (rawLeft === undefined)
        return null;
    const left = parseTotal(rawLeft);
    if (left === undefined)
        return null;
    return {
        left,
        charged: readHeader(headers, CREDIT_CHARGED_HEADER) === "true",
    };
};
//# sourceMappingURL=creditsHeaderBridge.js.map